import { useContext, useEffect, useMemo, useRef, useCallback } from "react";
import { ModalContext } from "./ModalContext";
import { ModalType } from "./types";

export const useModal = (modal: ModalType): [() => void, () => void] => {
  const { onOpenModal, onCloseModal } = useContext(ModalContext);
  const key = useMemo(() => Math.random().toString(36).substr(2, 9), []);
  const modalRef = useRef(modal);

  useEffect(() => {
    modalRef.current = modal;
  }, [modal]);

  const open = useCallback(() => {
    onOpenModal(key, modalRef.current);
  }, [key, onOpenModal]);

  const close = useCallback(() => {
    onCloseModal(key);
  }, [key, onCloseModal]);

  return [open, close];
};
